var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdgIconDe13(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 566.93335,
    height: 566.93335,
    viewBox: "0 0 566.93335 566.93335",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,566.93333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4254.1,-1.19141 H 0 V 4253.2 H 4254.1 V -1.19141",
    style: {
      fill: "#3e7131",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 536.969,3896.32 V 3038.91 H 392.777 v 656.32 h -1.261 L 290.391,3590.29 h -1.317 v 150.48 l 132.778,155.55 h 115.117",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1012.44,3710.38 v -74.58 c 0,-72.05 -39.194,-120.09 -98.62,-139.13 72.055,-16.41 106.21,-66.99 106.21,-145.4 V 3224.8 c 0,-118.86 -63.198,-196.01 -208.651,-196.01 -146.719,0 -198.613,83.47 -198.613,213.72 v 112.56 h 131.589 v -122.7 c 0,-50.58 17.657,-83.42 67.024,-83.42 44.199,0 64.414,31.57 64.414,77.14 v 141.61 c 0,45.57 -20.215,69.55 -70.77,69.55 h -60.668 v 110.03 h 54.395 c 46.754,0 77.043,24.06 77.043,69.55 v 92.32 c 0,46.81 -16.371,77.14 -61.887,77.14 -45.488,0 -61.961,-30.33 -61.961,-83.47 v -87.23 h -131.59 v 75.85 c 0,126.47 51.891,215.01 201.09,215.01 132.828,0 190.995,-74.64 190.995,-196.07",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2802.82,1434.62 c -17.61,4.82 -91.34,106.73 -33.05,173.8 9.69,11.03 -19.56,43.47 -11.56,44.11 31.88,2.46 48.85,-17.31 57.22,-45.84 0.64,-12.56 1.13,-25.24 1.13,-38.06 0,-45.92 -4.81,-90.73 -13.74,-134.01 m -179.84,-331.46 c -6.58,1.84 -13.32,3.97 -20.63,7.61 -35.83,18.25 -31.54,-10.9 -49.15,-4.48 -17.74,6.57 19.87,47.47 -33.08,12.88 -52.68,-34.49 -38.46,5.33 -61.46,63.76 -23.23,58.48 26.46,125.2 67.95,140.3 57.03,20.66 92.45,24.85 119.2,31.46 78.86,19.7 95.54,66.5 109.85,38.02 2.71,-5.33 5.31,-10.4 7.69,-15.18 4.6,-8.51 9.89,-25.75 10.14,-42.77 -33.47,-87.77 -85.13,-166.55 -150.51,-231.6 M 2159.93,912.031 c -64.16,0 -126.01,9.348 -184.54,26.438 -8.42,6.863 -13.22,18.332 -7.96,32.09 20.32,52.981 80.81,73.711 128.58,78.301 106.47,10.38 246.39,-69.11 268.64,-56.278 22.34,12.798 67.34,71.338 133.37,68.878 45.08,-1.73 44.75,-9.29 59.88,-15 -110.42,-84.241 -248.28,-134.429 -397.97,-134.429 m -89.28,427.939 c -9.03,-14.77 -33.72,-125.19 -50.29,-112.33 -16.65,12.88 6.72,128.06 11.52,136.82 25.91,47.56 82.02,45.21 38.77,-24.49 m 268.14,130.36 c -12.96,-11.53 -46.17,-7.31 -62.76,5.65 -16.5,12.83 10.48,34.14 20.34,34.93 22.1,1.97 55.28,-28.88 42.42,-40.58 m 289.77,-1.13 c -7.08,2.65 -13.33,9.35 -18.69,25.47 -5.34,16.12 8.2,25.31 21.44,18.84 13.49,-6.85 30.96,-26.95 30.96,-37.69 0,-10.75 -26.48,-9.46 -33.71,-6.62 m 27.91,-20.17 c 22.07,1.78 55.22,-28.8 42.26,-40.55 -12.91,-11.64 -46.01,-7.36 -62.61,5.61 -16.52,12.87 10.43,34.12 20.35,34.94 m -704.32,-261.81 c -12.75,-50.2 -27.65,-68.29 -40.35,-84.11 -12.68,-16.03 -59.69,-36.45 -89.51,-34.25 -29.87,2.24 -34.02,81.92 -34.02,122.9 0,14.16 -20.04,-27.81 -30.49,57.48 -6.69,54.62 -41.75,-5.69 -44.2,30.73 -2.5,36.35 -20.01,29.1 -38.44,51.82 -18.31,22.69 -41.15,-2.22 -66.77,-13.69 -25.45,-11.32 -14.97,-17.29 -51.19,-5.89 -0.93,0.29 -1.4,0.57 -2.3,0.89 -33.22,78.55 -51.58,164.91 -51.58,255.53 0,22.18 1.19,43.97 3.25,65.53 1.24,2.19 2.53,4.3 4.06,6.11 34.72,41.09 33.94,50.7 33.94,50.7 l 38.42,13.31 c 0,0 61.34,-9.45 107.55,-26.85 38.06,-14.27 98,-46.56 132.85,-32.35 25.21,10.39 44.93,24.17 42.55,45.16 -2.83,26.31 -23.57,32.57 -48.66,14.83 -9.27,-6.53 -28.99,39.68 -44.46,37.32 -15.46,-2.29 19.13,-54.28 6.02,-56.49 -13.17,-2.25 -39.61,54.2 -44.12,63.34 -4.45,9.07 -24.87,31.73 -43.2,14.44 -38.72,-36.78 -101.61,-34.54 -114.24,-44 -38.44,-28.76 -48.59,9.46 -47.73,32.74 1.55,5.33 3.12,10.7 4.83,15.96 12.55,13.84 57.59,18.42 73.06,8.11 16.99,-11.35 29.17,2.92 35.81,9.81 6.73,6.73 4.36,17.64 0.13,26.68 -4.32,9.13 8.49,15.8 17.27,18.15 8.85,2.35 38.11,22.83 49.77,29.66 11.8,6.78 72.5,14.15 99.71,0.55 27.18,-13.7 52.15,-2.52 65.52,13.23 16.78,19.9 38.14,35.08 47.61,39.68 9.52,4.45 -23.42,35.21 -50.5,1.68 -27.16,-33.36 -40.97,-36.45 -53.73,-36.45 -12.75,0 -88.55,18.92 -97.9,42.88 -9.24,23.9 23.71,41.83 51.69,55.4 27.96,13.34 104.51,13.15 124.08,17.58 39.78,8.72 90.64,28.71 116.25,11.27 25.51,-17.14 -106.98,-47.31 -63.43,-70.83 15.49,-8.5 85.53,40.3 109.54,52.79 56.46,29.12 -54.76,38.73 -40.32,97.94 16.31,66.91 -136.42,41.02 -212.56,35.34 102.11,65.42 223.37,103.46 353.57,103.46 309.75,0 569.21,-214.58 638.4,-503.11 0.46,-14.27 -1.75,-24.55 -3.2,-30.39 -5.93,-23.66 -50.84,-44.01 -76.88,-5.91 -6.64,9.6 -34.81,36.19 -33.85,-9.3 0.9,-45.51 44.22,-50.16 2.25,-77.48 -41.93,-27.29 -49.62,-20.71 -69.01,-27.59 -19.34,-6.84 -38.11,-53.74 -33.48,-78.79 4.69,-25.07 64.54,-93.5 20.13,-90.69 -10.41,0.77 -88.86,54.35 -101.82,88.81 -13.66,36.28 -28.58,71.77 -39.16,99.14 -10.72,27.25 -38.4,34.22 -61.87,18.18 -23.33,-16 6.53,-31.96 -10.27,-66.16 -16.73,-34.14 -28.76,-64.64 -53.42,-36.43 -64.07,73.44 -157.2,37.21 -171.81,118.93 -7.87,44.3 -46.03,40.05 -77.91,65.15 -32.07,24.94 -49.9,38.52 -55.3,20.45 -4.75,-15.86 100.35,-99.18 107.83,-120.53 11.15,-31.71 -31.47,-59.7 -62.68,-67.21 -31.05,-7.45 -44.76,17.51 -75.36,49.38 -30.57,31.8 -43.96,54.56 -46.08,29.56 -3.07,-36.11 29.04,-89.17 60.21,-108.99 26.56,-16.84 56.32,-24.46 47.73,-51.76 -8.65,-27.39 -0.16,-11.89 -29.92,-41.33 -29.82,-29.6 -35.5,-39.11 -33.34,-79.98 2.15,-41.02 -8.51,-43.36 -14.91,-77.44 -6.38,-34.09 -21.17,-4.59 -34.06,-54.6 m -352.71,723.59 c 1.5,1.79 2.84,3.24 3.41,3.98 11.85,13.5 35.44,16.39 51.76,18.94 16.34,2.8 38.14,-5.44 40.77,-16.3 2.78,-10.8 -40.97,-30.62 -48.98,-38.04 -22.67,-20.89 -58.16,-63.44 -78.92,-68.02 -6.79,-1.52 -12.37,-0.49 -16.96,1.78 13.66,34.03 29.97,66.76 48.92,97.66 m 33.67,66.95 c 8.49,12.47 36.71,48.07 40.14,52.56 7.25,9.35 21.66,11.25 31.78,13.05 10,1.94 23.34,-3.7 24.94,-11.22 1.73,-7.54 -3.87,-36.71 -8.8,-41.73 -13.82,-14.34 -49.8,-34.59 -69.63,-31.4 -15.34,2.35 -21.35,14.22 -18.43,18.74 m 2087.22,-387.98 c -112.07,157.21 -619.06,784.89 -1561.49,784.89 -942.57,0 -1449.414,-627.68 -1561.664,-784.89 -4.778,-6.72 -8.883,-12.53 -12.238,-17.47 3.355,-5.08 7.46,-10.86 12.238,-17.67 112.25,-157.13 619.094,-784.831 1561.664,-784.831 942.43,0 1449.42,627.701 1561.49,784.831 4.91,6.81 8.93,12.59 12.17,17.67 -3.24,4.94 -7.26,10.75 -12.17,17.47",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1458.79,3779.25 h -1.59 l -40.8,-233.18 h -28.09 l -45.04,233.18 h -1.06 v -233.18 h -49.82 v 359.31 h 70.49 l 39.21,-202.45 h 0.53 l 34.98,202.45 h 76.31 v -359.31 h -55.12 v 233.18",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1609.32,3660.01 h 48.22 l -23.84,144.14 h -0.53 z m -75.78,-113.94 67.83,359.31 h 68.89 l 68.36,-359.31 h -62 l -11.13,65.72 h -64.12 l -10.6,-65.72 h -57.23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1749.77,3623.45 v 48.22 h 56.17 v -49.28 c 0,-20.14 9.01,-31.8 29.68,-31.8 19.08,0 27.56,12.71 27.56,31.8 v 13.77 c 0,20.67 -8.48,33.39 -27.03,50.87 l -35.5,35.51 c -34.45,33.92 -50.35,54.59 -50.35,95.92 v 12.19 c 0,44.52 25.97,78.96 84.79,78.96 60.41,0 84.26,-29.68 84.26,-81.61 v -29.15 h -55.11 v 31.27 c 0,20.66 -9.54,30.74 -28.62,30.74 -16.96,0 -28.62,-9.54 -28.62,-29.68 v -7.42 c 0,-20.13 11.14,-31.8 28.62,-48.75 l 38.69,-38.16 c 32.85,-33.38 48.75,-53.52 48.75,-93.26 v -17.49 c 0,-49.29 -26.5,-84.26 -87.97,-84.26 -61.47,0 -85.32,34.44 -85.32,81.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1943.76,3623.45 v 48.22 h 56.17 v -49.28 c 0,-20.14 9.01,-31.8 29.68,-31.8 19.08,0 27.56,12.71 27.56,31.8 v 13.77 c 0,20.67 -8.48,33.39 -27.03,50.87 l -35.51,35.51 c -34.44,33.92 -50.34,54.59 -50.34,95.92 v 12.19 c 0,44.52 25.97,78.96 84.79,78.96 60.41,0 84.26,-29.68 84.26,-81.61 v -29.15 h -55.11 v 31.27 c 0,20.66 -9.54,30.74 -28.62,30.74 -16.96,0 -28.62,-9.54 -28.62,-29.68 v -7.42 c 0,-20.13 11.13,-31.8 28.62,-48.75 l 38.69,-38.16 c 32.85,-33.38 48.75,-53.52 48.75,-93.26 v -17.49 c 0,-49.29 -26.5,-84.26 -87.97,-84.26 -61.47,0 -85.32,34.44 -85.32,81.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2194.44,3771.83 v -225.76 h -50.87 v 359.31 h 59.36 l 65.17,-206.15 v 206.15 h 50.35 v -359.31 h -52.99 l -71.02,225.76",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2413.86,3660.01 h 48.23 l -23.85,144.14 h -0.53 z m -75.78,-113.94 67.83,359.31 h 68.89 l 68.36,-359.31 h -62 l -11.12,65.72 h -64.13 l -10.6,-65.72 h -57.23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2681.49,3704.52 h -58.29 v -158.45 h -60.41 v 359.31 h 60.41 v -152.1 h 58.29 v 152.1 h 60.95 v -359.31 h -60.95 v 158.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2938,3779.25 h -1.58 l -40.81,-233.18 h -28.08 l -45.05,233.18 h -1.06 v -233.18 h -49.81 v 359.31 h 70.48 l 39.21,-202.45 h 0.53 l 34.98,202.45 h 76.31 V 3546.07 H 2938 v 233.18",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3022.29,3905.38 h 144.14 v -49.29 h -83.73 v -102.81 h 59.88 v -48.76 h -59.88 v -109.16 h 83.73 v -49.29 h -144.14 v 359.31",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3244.34,3771.83 v -225.76 h -50.87 v 359.31 h 59.36 L 3318,3699.23 v 206.15 h 50.36 v -359.31 h -53 l -71.02,225.76",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3506.7,3595.36 h 91.67 v -49.29 h -154.74 v 49.29 l 94.86,260.73 h -85.32 v 49.29 h 148.92 v -49.29 l -95.39,-260.73",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3804.01,3905.38 v -271.86 c 0,-55.64 -23.85,-91.68 -85.31,-91.68 -63.6,0 -90.1,36.04 -90.1,91.68 v 271.86 h 60.42 v -277.69 c 0,-21.21 8.48,-35.51 29.68,-35.51 21.19,0 29.67,14.3 29.67,35.51 v 277.69 h 55.64",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3999.58,3779.25 h -1.59 l -40.81,-233.18 h -28.08 l -45.05,233.18 h -1.06 v -233.18 h -49.81 v 359.31 h 70.48 l 39.22,-202.45 h 0.52 l 34.98,202.45 h 76.31 v -359.31 h -55.11 v 233.18",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1352.81,3220.95 v -174.87 h -60.42 v 359.3 h 60.42 v -157.93 l 65.71,157.93 h 59.35 l -69.95,-161.64 71.54,-197.66 h -63.59 l -63.06,174.87",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1496.97,3405.38 h 60.42 v -310.03 h 72.07 v -49.27 h -132.49 v 359.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1651.72,3405.38 h 60.42 v -359.3 h -60.42 v 359.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1908.22,3279.25 h -1.58 l -40.81,-233.17 h -28.09 l -45.04,233.17 h -1.06 v -233.17 h -49.82 v 359.3 h 70.49 l 39.21,-202.45 h 0.53 l 34.98,202.45 h 76.31 v -359.3 h -55.12 v 233.17",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2058.75,3160.01 h 48.22 l -23.84,144.14 h -0.53 z m -75.78,-113.93 67.83,359.3 h 68.89 l 68.36,-359.3 h -62 l -11.13,65.71 h -64.12 l -10.6,-65.71 h -57.23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2199.21,3123.45 v 48.22 h 56.17 v -49.29 c 0,-20.13 9,-31.79 29.67,-31.79 19.08,0 27.56,12.71 27.56,31.79 v 13.78 c 0,20.67 -8.48,33.39 -27.03,50.87 l -35.51,35.51 c -34.44,33.92 -50.34,54.59 -50.34,95.92 v 12.19 c 0,44.52 25.97,78.96 84.8,78.96 60.41,0 84.26,-29.68 84.26,-81.61 v -29.15 h -55.12 v 31.27 c 0,20.66 -9.54,30.74 -28.62,30.74 -16.96,0 -28.62,-9.54 -28.62,-29.68 v -7.42 c 0,-20.13 11.13,-31.8 28.62,-48.75 l 38.69,-38.16 c 32.86,-33.38 48.76,-53.52 48.76,-93.26 v -17.49 c 0,-49.29 -26.51,-84.26 -87.97,-84.26 -61.48,0 -85.32,34.44 -85.32,81.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2399.01,3138.81 v 173.82 c 0,56.18 26.49,96.98 90.09,96.98 66.77,0 85.32,-37.1 85.32,-90.09 v -42.39 h -55.12 v 47.16 c 0,22.26 -7.42,34.98 -29.14,34.98 -21.73,0 -30.74,-15.37 -30.74,-37.1 v -192.9 c 0,-21.72 9.01,-37.09 30.74,-37.09 21.72,0 29.14,13.78 29.14,34.97 v 66.25 h 55.12 v -62 c 0,-51.41 -21.2,-89.56 -85.32,-89.56 -63.6,0 -90.09,41.33 -90.09,96.97",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2720.7,3204.52 h -58.29 V 3046.08 H 2602 v 359.3 h 60.41 v -152.1 h 58.29 v 152.1 h 60.95 v -359.3 h -60.95 v 158.44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2986.23,3405.38 v -271.86 c 0,-55.65 -23.85,-91.68 -85.33,-91.68 -63.59,0 -90.08,36.03 -90.08,91.68 v 271.86 h 60.41 v -277.69 c 0,-21.2 8.47,-35.51 29.67,-35.51 21.21,0 29.68,14.31 29.68,35.51 v 277.69 h 55.65",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3008.5,3405.38 h 160.57 v -49.29 h -49.82 v -310.01 h -60.93 v 310.01 h -49.82 v 49.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3242.75,3095.35 h 91.68 v -49.27 h -154.75 v 49.27 l 94.87,260.74 h -85.33 v 49.29 h 148.92 v -49.29 l -95.39,-260.74",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdgIconDe13);
export default __webpack_public_path__ + "static/media/SDG-icon-DE-13.54dd330c614935cc74083cec59cb9106.svg";
export { ForwardRef as ReactComponent };